import { AxiosInstance, AxiosResponse } from "axios";
import { ApiError, ApiResult, BaseServiceInterface } from "./types";
import { parseAxiosError } from "./apiClient";

export abstract class BaseService implements BaseServiceInterface {
  protected client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  protected async handleRequest<T>(
    request: Promise<AxiosResponse<T>>,
  ): Promise<ApiResult<T>> {
    try {
      const response = await request;
      return {
        success: true,
        data: response.data,
      };
    } catch (error: unknown) {
      return {
        success: false,
        error: parseAxiosError(error),
      };
    }
  }

  protected buildQueryParams(params: Record<string, unknown>): Record<string, unknown> {
    // Filter out undefined values
    const filteredParams: Record<string, unknown> = {};

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        filteredParams[key] = value;
      }
    });

    return filteredParams;
  }

  protected async handleRequestWithThrow<T>(
    request: Promise<AxiosResponse<T>>,
  ): Promise<T> {
    const result = await this.handleRequest(request);

    if (!result.success) {
      const error = new Error(result.error.message) as Error & { apiError?: ApiError };
      error.apiError = result.error;
      throw error;
    }

    return result.data;
  }
}
